import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "@irati/store"
import {map} from "lodash"

import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import TeamActions from "@irati/identity/store/actions/TeamActions"

export const schema = Validation.array("platform.defaultValidation.required").of(Validation.string("platform.defaultValidation.required"))

const PROPERTY = "teams"

class Teams extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    getTeams: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    validation: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    validation: schema,
    label: "recognition.fields.poll.teams.label",
    placeholder: "recognition.fields.poll.teams.placeholder",
    id: "poll"
  }

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true
    }
  }

  componentDidMount() {
    this.props.getTeams().then(() => {
      this.setState({isLoading: false})
    })
  }

  handleChange = (value) => {
    const {poll, onChange} = this.props
    onChange(poll, PROPERTY, map(value, "value"))
  }

  render() {
    const {isLoading} = this.state
    const {poll, intl, options, ...props} = this.props
    const selected = poll[PROPERTY]
    const selectedValues = selected && options ? options.filter(({value}) => selected.includes(value)) : undefined

    return (
      <Select
        isMulti
        options={options}
        isLoading={isLoading}
        {...props}
        hint={options.length === 0 ? intl.formatMessage({id: "recognition.fields.poll.teams.hint"}) : null}
        onChange={this.handleChange}
        id={id(PROPERTY, this.props)}
        name={id(PROPERTY, this.props)}
        value={selectedValues}
      />
    )
  }
}

const actions = (dispatch) => {
  return {
    getTeams: () => dispatch(TeamActions.get(authentication.userTenant()))
  }
}

const mapStateToProps = ({teams}) => {
  const options = teams.list.map((team) => ({value: team.uuid, label: team.public_name}))
  options.load = teams.list.load
  return {
    options
  }
}

export default injectIntl(connect(mapStateToProps, actions)(Teams))
